export const ROUTES = {
  BASE_URL: "/",
  SITE_DOWN: "/site-down",
  SELECT_CAT: "/select-cat",
  HOME_SCREEN: "/home",
  SEARCH: "/search",
  FILTER: "/filter",
  PRODUCT_DETAILED: "/product-detailed",
  PRODUCT_DETAILEDIT: "/product-detailedit",
  APP_ORDERS: "/orders",
  APP_ASSISTANCE: "/assistance",
  PAYMENT: "/payment",
  APPLEPAY: "/applePay",
  SAMSUNGPAY: "/samsungPay",
  CHARGE_TO_ROOM: "/charge-to-room",
  FACE_RECOG: "/face-recog",
  LOGIN: "/login",
  REGISTER: "/register",
  EMAIL_VERIFY: "/emailVerify",
  FORGOT_PASS: "/forgot-password",
  RESET_PASS: "/setPassword",
  PROFILE_VIEW: "/profile",
  ORDER_HISTORY: "/orderHistory",
  POST_PAYMENT_PROCESS: "/postPaymentProcess",
  MANAGE_USERS: "/manageUsers",
  // FOOD_SCREEN: "/",
};
